module.exports = __webpack_public_path__ + "img/zdd_profile_com_invite.952ce11f.png";